import { GameConstants } from "../../GameConstants";
import { Card } from "./Card";
import { Board } from "./Board";
import { AudioManager } from "../../AudioManager";

export class FoundationPile extends Phaser.Group {

    public pileX: number;
    public pileY: number;
    public kingsPile: boolean;
    public completed: boolean;
    public covered: boolean;
    public i: number;
    public boundingRectangle: Phaser.Rectangle;
    
    private shine: Phaser.Image;
            
    constructor(game: Phaser.Game, x: number, y: number ) {

        super(game, null, "foundation-pile");
        
        this.kingsPile = false;
        this.completed = false;
        this.covered = false;
        
        this.pileX = x;
        this.pileY = y;
        
        this.boundingRectangle = new Phaser.Rectangle(this.pileX - GameConstants.HALF_CARD_WIDTH , this.pileY - GameConstants.HALF_CARD_HEIGHT,
                                                        GameConstants.CARD_WIDTH, GameConstants.CARD_HEIGHT);
        
        if (GameConstants.SHOW_BOUNDING_AREAS) {
            
            var boundingRectangleSprite: Phaser.Sprite = new Phaser.Sprite(this.game, this.pileX  - GameConstants.HALF_CARD_WIDTH, this.pileY - GameConstants.HALF_CARD_HEIGHT, this.game.cache.getBitmapData("yellow-square"));
            boundingRectangleSprite.scale.setTo(GameConstants.CARD_WIDTH / 16, GameConstants.CARD_HEIGHT / 16);
            boundingRectangleSprite.alpha = .3;
            this.addChild(boundingRectangleSprite);
        }
    }

    public destroy(destroyChildren?: boolean, soft?: boolean): void {

        super.destroy(destroyChildren, soft);
    }

    public update(): void {

        super.update();
    }
    
    public addCard(card: Card, startGame?: boolean, tween?: boolean): void {
        
        if (!startGame) {

                if (tween) {
                
                Card.cardTweening = true;
                
                Board.currentInstance.bringToTop(this);
                
                this.game.add.tween(card)
                    .to({x: this.pileX , y: this.pileY }, 300 , Phaser.Easing.Cubic.Out, true)
                    .onComplete.add(function(): void{
                        Card.cardTweening = false;
                    }, this);
                
                this.game.add.tween(card)
                    .to({angle: 0 }, 300 , Phaser.Easing.Cubic.Out, true);
                
            } else {
                
                card.x = this.pileX;
                card.y = this.pileY;
                card.angle = 0;
                
            }
                        
        } else {
            card.x = 0;
            card.y = 700;
            card.angle = 0;
        }

        card.foundationPileIndex = this.i;
        card.outerPileIndex = -1;
                    
        if (this.kingsPile) {
            if (card.cardValue.value === "A") {
                this.completed = true;
            }
        } else {
            if (card.cardValue.value === "K") {
                this.completed = true;
            }
        } 
        
        this.add(card);
    }
    
    public coverPile(): void {
        
        this.covered = true;
        
        var card: Card;
        
        for (var i: number = 1; i < this.length; i++) {
            card = <Card> this.getAt(i);
            card.disableDrag();
        }
        
        this.shine = new Phaser.Image(this.game, this.pileX, this.pileY, "texture_atlas_2", "brillo_palo_completo.png");
        this.shine.anchor.setTo(.5, .5);
        this.shine.scale.setTo(0, 0);
        this.add(this.shine);
        
        var cardBack: Phaser.Image = new Phaser.Image(this.game, this.pileX, this.pileY, "texture_atlas_2", "card-back.png");
        cardBack.anchor.setTo(.5, .5);
        cardBack.alpha = 0;
        this.add(cardBack);
        
        this.game.add.tween(this.shine.scale)
            .to({x: 1.1, y: 1.1 }, 450 , Phaser.Easing.Cubic.Out, true, 250)
            .onComplete.add(function(): void {
                    this.game.add.tween(this.shine)
                    .to({alpha: 0 }, 450 , Phaser.Easing.Cubic.Out, true)
                    .onComplete.add(function(): void {
                        this.shine.destroy();
                    }, this);
            }, this);
        
        this.game.add.tween(cardBack)
            .to({alpha: 1 }, 450 , Phaser.Easing.Cubic.Out, true, 180);      
            
        // audio
        AudioManager.getInstance().playSound("Impacto_cristal_verde");  
    }
    
    public getValueUpperCard(): CardValue {
        
        if (!this.covered) {
            var upperCard: Card = <Card> this.getTop();
            return upperCard.cardValue;
        } else {
            return null;
        }     
    }
    
    public getUpperCard(): Card {
        
        if (!this.covered) {
            var upperCard: Card = <Card> this.getTop();
            return upperCard;
        } else {
            return null;
        } 
    }
}
